import React, { useState } from "react";
import { toast } from 'react-toastify';
import { requestDeleteAddressAsync } from "../../API/Address/RequestDeleteAddressAsync.ts";

interface DeleteModalProps {
  isOpen: boolean;
  addressId: string;
  t: (key: string) => string;
  onClose: () => void;
  onSuccess?: () => void;
  onError?: (msg: string) => void;
  navigate: (path: string) => void;
  setErrorMessage: (msg: string) => void;
  setSuccessMessage: (msg: string) => void;
  setAddresses: React.Dispatch<React.SetStateAction<any[]>>;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  addressId,
  t,
  onClose,
  onSuccess,
  onError,
  navigate,
  setErrorMessage,
  setSuccessMessage,
  setAddresses,
}) => {
  const [deleteReason, setDeleteReason] = useState("");
  const [isFormChanged, setIsFormChanged] = useState(false);

  React.useEffect(() => {
    setIsFormChanged(deleteReason.trim().length > 0);
  }, [deleteReason]);

  const handleSubmit = async () => {
    const id = addressId;
    if (!id) {
      toast.error(t("addressIdMissing"));
      onError && onError(t("addressIdMissing"));
      return;
    }
    const token = localStorage.getItem('token');
    if (!token) {
      setErrorMessage(t("sessionExpired"));
      navigate('/');
      return;
    }
    try {
      await requestDeleteAddressAsync(parseInt(id), deleteReason, token);
      setAddresses((prevAddresses: any[]) =>
        prevAddresses.map((address) =>
          address.id === id ? { ...address, isDeleteRequestSubmitted: true } : address
        )
      );
      setDeleteReason("");
      onClose();
      setTimeout(() => {
        setSuccessMessage("");
        navigate("/home");
      }, 3000);
      onSuccess && onSuccess();
    } catch (error) {
      setErrorMessage(t("deleteRequestfailed"));
      onError && onError(t("deleteRequestfailed"));
    }
  };

  if (!isOpen) return null;
  return (
    <div className="fixed -inset-4 bg-gray-500 bg-opacity-50 flex justify-center items-center z-[1000]">
      <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-2/6">
        <h2 className="text-xl font-bold mb-4">
          {t("deleteAddress")}
        </h2>
        <p>
          {t("deleteRequestConfirm")}
        </p>
        <textarea
          className="w-full mt-4 p-2 border border-gray-300 rounded-md"
          placeholder={t("deleteReason")}
          value={deleteReason}
          onChange={(e) => setDeleteReason(e.target.value)}
        />
        <div className="mt-4 flex justify-between">
          <button
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
            onClick={() => {
              setDeleteReason("");
              onClose();
            }}
          >
            {t("cancel")}
          </button>
          <button
            className={`px-4 py-2 text-white rounded-md ${isFormChanged
              ? 'bg-blue-600 hover:bg-blue-700'
              : 'bg-gray-400 cursor-not-allowed'
              }`}
            onClick={handleSubmit}
            disabled={!isFormChanged}
          >
            {t("submit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
